"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDetailSaleList = exports.defaultDistrictSale = exports.defaultDistrictRent = void 0;
var ResultPageState_1 = require("@/pages/search/states/ResultPageState");
exports.defaultDistrictRent = [
    {
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.UNKNOWN,
        images: [
            {
                path: 'https://images.okay.com/Property/Folder150/293415_635569341192383658.jpg',
                caption: 'Property Photo',
            },
        ],
        building: 'Positano Discovery Bay',
        area: 'Discovery Bay',
        address: '18 Bayside Drive',
        type: 2,
        price: 120000000,
        salePrice: 39000000,
        leasePrice: 120000,
        pricePerSqft: 71,
        leasePricePerSqftGross: 0,
        salePricePerSqftGross: 0,
        leasePricePerSqftSaleable: 71,
        salePricePerSqftSaleable: 23036,
        leasePricePerSqft: 71,
        salePricePerSqft: 23036,
        size: 1693,
        sizeGross: 0,
        sizeSaleable: 1693,
        amenities: [
            {
                key: 'bed',
                value: 2,
                displayKey: 'Bedrooms',
                displayValue: '2 BD',
            },
            {
                key: 'bath',
                value: 3,
                displayKey: 'Bathroom',
                displayValue: '3 BA',
            },
            {
                key: 'maid',
                value: 1,
                displayKey: "Maid's Room",
                displayValue: '1 MR',
            },
            {
                key: 'balcony',
                value: 1,
                displayKey: 'Balcony',
                displayValue: '1 BL',
            },
            {
                key: 'roof',
                value: 1,
                displayKey: 'Rooftop',
                displayValue: '1 RF',
            },
            {
                key: 'terrace',
                value: 1,
                displayKey: 'Terrace',
                displayValue: '1 TR',
            },
        ],
        buildingAge: 5,
        floor: 'High',
        isSaved: false,
        isSaving: false,
        lastUpdated: '2018-09-11T17:34:23',
        referenceId: 293415,
        lat: 22.307107,
        lng: 114.014794,
        isRelated: false,
        isSaleSubjectToOffer: false,
        isLeaseSubjectToOffer: false,
        isSubjectToOffer: false,
    },
    {
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.UNKNOWN,
        images: [
            {
                path: 'https://images.okay.com/Property/Folder150/295096_635737845322906501.JPG',
                caption: 'Property Photo',
            },
        ],
        building: 'Amalfi',
        area: 'Discovery Bay',
        address: '8 Amalfi Drive',
        type: 1,
        price: 54000000,
        salePrice: 0,
        leasePrice: 54000,
        pricePerSqft: 57,
        leasePricePerSqftGross: 44,
        salePricePerSqftGross: 0,
        leasePricePerSqftSaleable: 57,
        salePricePerSqftSaleable: 0,
        leasePricePerSqft: 57,
        salePricePerSqft: 0,
        size: 952,
        sizeGross: 1230,
        sizeSaleable: 952,
        amenities: [
            {
                key: 'bed',
                value: 3,
                displayKey: 'Bedrooms',
                displayValue: '3 BD',
            },
            {
                key: 'bath',
                value: 2,
                displayKey: 'Bathroom',
                displayValue: '2 BA',
            },
            {
                key: 'balcony',
                value: 1,
                displayKey: 'Balcony',
                displayValue: '1 BL',
            },
        ],
        buildingAge: 8,
        floor: 'High',
        isSaved: false,
        isSaving: false,
        lastUpdated: '2018-09-20T15:19:42',
        referenceId: 295096,
        lat: 22.307009,
        lng: 114.014303,
        isRelated: false,
        isSaleSubjectToOffer: false,
        isLeaseSubjectToOffer: false,
        isSubjectToOffer: false,
    },
    {
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.UNKNOWN,
        images: [
            {
                path: 'https://images.okay.com/Property/Folder150/295062_635761756452389187.JPG',
                caption: 'Property Photo',
            },
        ],
        building: 'Amalfi',
        area: 'Discovery Bay',
        address: '8 Amalfi Drive',
        type: 2,
        price: 100000000,
        salePrice: 40000000,
        leasePrice: 100000,
        pricePerSqft: 58,
        leasePricePerSqftGross: 0,
        salePricePerSqftGross: 0,
        leasePricePerSqftSaleable: 58,
        salePricePerSqftSaleable: 23095,
        leasePricePerSqft: 58,
        salePricePerSqft: 23095,
        size: 1732,
        sizeGross: 0,
        sizeSaleable: 1732,
        amenities: [
            {
                key: 'bed',
                value: 3,
                displayKey: 'Bedrooms',
                displayValue: '3 BD',
            },
            {
                key: 'bath',
                value: 4,
                displayKey: 'Bathroom',
                displayValue: '4 BA',
            },
            {
                key: 'maid',
                value: 1,
                displayKey: "Maid's Room",
                displayValue: '1 MR',
            },
            {
                key: 'balcony',
                value: 2,
                displayKey: 'Balcony',
                displayValue: '2 BL',
            },
        ],
        buildingAge: 8,
        floor: 'High',
        isSaved: false,
        isSaving: false,
        lastUpdated: '2018-09-10T14:40:16',
        referenceId: 295062,
        lat: 22.307009,
        lng: 114.014303,
        isRelated: false,
        isSaleSubjectToOffer: false,
        isLeaseSubjectToOffer: false,
        isSubjectToOffer: false,
    },
    {
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.UNKNOWN,
        images: [
            {
                path: 'https://images.okay.com/Property/Folder150/296974_636718501594729307.jpg',
                caption: 'Property Photo',
            },
        ],
        building: 'La Costa - Low Rise',
        area: 'Discovery Bay',
        address: '2-22 Costa Avenue',
        type: 1,
        price: 60000000,
        salePrice: 0,
        leasePrice: 60000,
        pricePerSqft: 51,
        leasePricePerSqftGross: 45,
        salePricePerSqftGross: 0,
        leasePricePerSqftSaleable: 51,
        salePricePerSqftSaleable: 0,
        leasePricePerSqft: 51,
        salePricePerSqft: 0,
        size: 1183,
        sizeGross: 1327,
        sizeSaleable: 1183,
        amenities: [
            {
                key: 'bed',
                value: 3,
                displayKey: 'Bedrooms',
                displayValue: '3 BD',
            },
            {
                key: 'bath',
                value: 2,
                displayKey: 'Bathroom',
                displayValue: '2 BA',
            },
            {
                key: 'balcony',
                value: 3,
                displayKey: 'Balcony',
                displayValue: '3 BL',
            },
        ],
        buildingAge: 24,
        floor: 'High',
        isSaved: false,
        isSaving: false,
        lastUpdated: '2018-09-10T13:15:43',
        referenceId: 296974,
        lat: 22.295272,
        lng: 114.018749,
        isRelated: false,
        isSaleSubjectToOffer: false,
        isLeaseSubjectToOffer: false,
        isSubjectToOffer: false,
    },
    {
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.UNKNOWN,
        images: [
            {
                path: 'https://images.okay.com/Property/Folder150/48177_636735773100119162.jpg',
                caption: 'Property Photo',
            },
        ],
        building: 'Peninsula Village - Caperidge Drive',
        area: 'Discovery Bay',
        address: '1-39 Caperidge Drive',
        type: 2,
        price: 60000000,
        salePrice: 18000000,
        leasePrice: 60000,
        pricePerSqft: 44,
        leasePricePerSqftGross: 37,
        salePricePerSqftGross: 11125,
        leasePricePerSqftSaleable: 44,
        salePricePerSqftSaleable: 13245,
        leasePricePerSqft: 44,
        salePricePerSqft: 13245,
        size: 1359,
        sizeGross: 1618,
        sizeSaleable: 1359,
        amenities: [
            {
                key: 'bed',
                value: 3,
                displayKey: 'Bedrooms',
                displayValue: '3 BD',
            },
            {
                key: 'bath',
                value: 2,
                displayKey: 'Bathroom',
                displayValue: '2 BA',
            },
            {
                key: 'balcony',
                value: 1,
                displayKey: 'Balcony',
                displayValue: '1 BL',
            },
            {
                key: 'roof',
                value: 2,
                displayKey: 'Rooftop',
                displayValue: '2 RF',
            },
        ],
        buildingAge: 28,
        floor: 'High',
        isSaved: false,
        isSaving: false,
        lastUpdated: '2018-09-26T17:02:30',
        referenceId: 48177,
        lat: 22.295891,
        lng: 114.022047,
        isRelated: false,
        isSaleSubjectToOffer: false,
        isLeaseSubjectToOffer: false,
        isSubjectToOffer: false,
    },
    {
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.UNKNOWN,
        images: [
            {
                path: 'https://images.okay.com/Property/Folder150/296046_635762906183924584.jpg',
                caption: 'Property Photo',
            },
        ],
        building: 'Chianti - The Pavilion(Block 1)',
        area: 'Discovery Bay',
        address: '2 Chianti Drive',
        type: 1,
        price: 58000000,
        salePrice: 0,
        leasePrice: 58000,
        pricePerSqft: 34,
        leasePricePerSqftGross: 26,
        salePricePerSqftGross: 0,
        leasePricePerSqftSaleable: 34,
        salePricePerSqftSaleable: 0,
        leasePricePerSqft: 34,
        salePricePerSqft: 0,
        size: 1730,
        sizeGross: 2248,
        sizeSaleable: 1730,
        amenities: [
            {
                key: 'bed',
                value: 4,
                displayKey: 'Bedrooms',
                displayValue: '4 BD',
            },
            {
                key: 'bath',
                value: 4,
                displayKey: 'Bathroom',
                displayValue: '4 BA',
            },
            {
                key: 'maid',
                value: 1,
                displayKey: "Maid's Room",
                displayValue: '1 MR',
            },
            {
                key: 'balcony',
                value: 2,
                displayKey: 'Balcony',
                displayValue: '2 BL',
            },
        ],
        buildingAge: 13,
        floor: 'Low',
        isSaved: false,
        isSaving: false,
        lastUpdated: '2018-09-18T15:02:47',
        referenceId: 296046,
        lat: 22.308039,
        lng: 114.012889,
        isRelated: false,
        isSaleSubjectToOffer: false,
        isLeaseSubjectToOffer: false,
        isSubjectToOffer: false,
    },
];
exports.defaultDistrictSale = [
    {
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.UNKNOWN,
        images: [
            {
                path: 'https://images.okay.com/Property/Folder150/293415_635569341192383658.JPG',
                caption: 'Property Photo',
            },
        ],
        building: 'Positano Discovery Bay',
        area: 'Discovery Bay',
        address: '18 Bayside Drive',
        type: 2,
        price: 120000000,
        salePrice: 39000000,
        leasePrice: 120000,
        pricePerSqft: 71,
        leasePricePerSqftGross: 0,
        salePricePerSqftGross: 0,
        leasePricePerSqftSaleable: 71,
        salePricePerSqftSaleable: 23036,
        leasePricePerSqft: 71,
        salePricePerSqft: 23036,
        size: 1693,
        sizeGross: 0,
        sizeSaleable: 1693,
        amenities: [
            {
                key: 'bed',
                value: 2,
                displayKey: 'Bedrooms',
                displayValue: '2 BD',
            },
            {
                key: 'bath',
                value: 3,
                displayKey: 'Bathroom',
                displayValue: '3 BA',
            },
            {
                key: 'maid',
                value: 1,
                displayKey: "Maid's Room",
                displayValue: '1 MR',
            },
            {
                key: 'balcony',
                value: 1,
                displayKey: 'Balcony',
                displayValue: '1 BL',
            },
            {
                key: 'roof',
                value: 1,
                displayKey: 'Rooftop',
                displayValue: '1 RF',
            },
            {
                key: 'terrace',
                value: 1,
                displayKey: 'Terrace',
                displayValue: '1 TR',
            },
        ],
        buildingAge: 5,
        floor: 'High',
        isSaved: false,
        isSaving: false,
        lastUpdated: '2018-09-11T17:34:23',
        referenceId: 293415,
        lat: 22.307107,
        lng: 114.014794,
        isRelated: false,
        isSaleSubjectToOffer: false,
        isLeaseSubjectToOffer: false,
        isSubjectToOffer: false,
    },
    {
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.UNKNOWN,
        images: [
            {
                path: 'https://images.okay.com/Property/Folder150/295096_635737845322906501.JPG',
                caption: 'Property Photo',
            },
        ],
        building: 'Amalfi',
        area: 'Discovery Bay',
        address: '8 Amalfi Drive',
        type: 1,
        price: 54000000,
        salePrice: 0,
        leasePrice: 54000,
        pricePerSqft: 57,
        leasePricePerSqftGross: 44,
        salePricePerSqftGross: 0,
        leasePricePerSqftSaleable: 57,
        salePricePerSqftSaleable: 0,
        leasePricePerSqft: 57,
        salePricePerSqft: 0,
        size: 952,
        sizeGross: 1230,
        sizeSaleable: 952,
        amenities: [
            {
                key: 'bed',
                value: 3,
                displayKey: 'Bedrooms',
                displayValue: '3 BD',
            },
            {
                key: 'bath',
                value: 2,
                displayKey: 'Bathroom',
                displayValue: '2 BA',
            },
            {
                key: 'balcony',
                value: 1,
                displayKey: 'Balcony',
                displayValue: '1 BL',
            },
        ],
        buildingAge: 8,
        floor: 'High',
        isSaved: false,
        isSaving: false,
        lastUpdated: '2018-09-20T15:19:42',
        referenceId: 295096,
        lat: 22.307009,
        lng: 114.014303,
        isRelated: false,
        isSaleSubjectToOffer: false,
        isLeaseSubjectToOffer: false,
        isSubjectToOffer: false,
    },
    {
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.UNKNOWN,
        images: [
            {
                path: 'https://images.okay.com/Property/Folder150/295062_635761756452389187.JPG',
                caption: 'Property Photo',
            },
        ],
        building: 'Amalfi',
        area: 'Discovery Bay',
        address: '8 Amalfi Drive',
        type: 2,
        price: 100000000,
        salePrice: 40000000,
        leasePrice: 100000,
        pricePerSqft: 58,
        leasePricePerSqftGross: 0,
        salePricePerSqftGross: 0,
        leasePricePerSqftSaleable: 58,
        salePricePerSqftSaleable: 23095,
        leasePricePerSqft: 58,
        salePricePerSqft: 23095,
        size: 1732,
        sizeGross: 0,
        sizeSaleable: 1732,
        amenities: [
            {
                key: 'bed',
                value: 3,
                displayKey: 'Bedrooms',
                displayValue: '3 BD',
            },
            {
                key: 'bath',
                value: 4,
                displayKey: 'Bathroom',
                displayValue: '4 BA',
            },
            {
                key: 'maid',
                value: 1,
                displayKey: "Maid's Room",
                displayValue: '1 MR',
            },
            {
                key: 'balcony',
                value: 2,
                displayKey: 'Balcony',
                displayValue: '2 BL',
            },
        ],
        buildingAge: 8,
        floor: 'High',
        isSaved: false,
        isSaving: false,
        lastUpdated: '2018-09-10T14:40:16',
        referenceId: 295062,
        lat: 22.307009,
        lng: 114.014303,
        isRelated: false,
        isSaleSubjectToOffer: false,
        isLeaseSubjectToOffer: false,
        isSubjectToOffer: false,
    },
    {
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.UNKNOWN,
        images: [
            {
                path: 'https://images.okay.com/Property/Folder150/296974_636718501594729307.JPG',
                caption: 'Property Photo',
            },
        ],
        building: 'La Costa - Low Rise',
        area: 'Discovery Bay',
        address: '2-22 Costa Avenue',
        type: 1,
        price: 60000000,
        salePrice: 0,
        leasePrice: 60000,
        pricePerSqft: 51,
        leasePricePerSqftGross: 45,
        salePricePerSqftGross: 0,
        leasePricePerSqftSaleable: 51,
        salePricePerSqftSaleable: 0,
        leasePricePerSqft: 51,
        salePricePerSqft: 0,
        size: 1183,
        sizeGross: 1327,
        sizeSaleable: 1183,
        amenities: [
            {
                key: 'bed',
                value: 3,
                displayKey: 'Bedrooms',
                displayValue: '3 BD',
            },
            {
                key: 'bath',
                value: 2,
                displayKey: 'Bathroom',
                displayValue: '2 BA',
            },
            {
                key: 'balcony',
                value: 3,
                displayKey: 'Balcony',
                displayValue: '3 BL',
            },
        ],
        buildingAge: 24,
        floor: 'High',
        isSaved: false,
        isSaving: false,
        lastUpdated: '2018-09-10T13:15:43',
        referenceId: 296974,
        lat: 22.295272,
        lng: 114.018749,
        isRelated: false,
        isSaleSubjectToOffer: false,
        isLeaseSubjectToOffer: false,
        isSubjectToOffer: false,
    },
    {
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.UNKNOWN,
        images: [
            {
                path: 'https://images.okay.com/Property/Folder150/48177_636735773100119162.JPG',
                caption: 'Property Photo',
            },
        ],
        building: 'Peninsula Village - Caperidge Drive',
        area: 'Discovery Bay',
        address: '1-39 Caperidge Drive',
        type: 2,
        price: 60000000,
        salePrice: 18000000,
        leasePrice: 60000,
        pricePerSqft: 44,
        leasePricePerSqftGross: 37,
        salePricePerSqftGross: 11125,
        leasePricePerSqftSaleable: 44,
        salePricePerSqftSaleable: 13245,
        leasePricePerSqft: 44,
        salePricePerSqft: 13245,
        size: 1359,
        sizeGross: 1618,
        sizeSaleable: 1359,
        amenities: [
            {
                key: 'bed',
                value: 3,
                displayKey: 'Bedrooms',
                displayValue: '3 BD',
            },
            {
                key: 'bath',
                value: 2,
                displayKey: 'Bathroom',
                displayValue: '2 BA',
            },
            {
                key: 'balcony',
                value: 1,
                displayKey: 'Balcony',
                displayValue: '1 BL',
            },
            {
                key: 'roof',
                value: 2,
                displayKey: 'Rooftop',
                displayValue: '2 RF',
            },
        ],
        buildingAge: 28,
        floor: 'High',
        isSaved: false,
        isSaving: false,
        lastUpdated: '2018-09-26T17:02:30',
        referenceId: 48177,
        lat: 22.295891,
        lng: 114.022047,
        isRelated: false,
        isSaleSubjectToOffer: false,
        isLeaseSubjectToOffer: false,
        isSubjectToOffer: false,
    },
    {
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.UNKNOWN,
        images: [
            {
                path: 'https://images.okay.com/Property/Folder150/296046_635762906183924584.JPG',
                caption: 'Property Photo',
            },
        ],
        building: 'Chianti - The Pavilion(Block 1)',
        area: 'Discovery Bay',
        address: '2 Chianti Drive',
        type: 1,
        price: 58000000,
        salePrice: 0,
        leasePrice: 58000,
        pricePerSqft: 34,
        leasePricePerSqftGross: 26,
        salePricePerSqftGross: 0,
        leasePricePerSqftSaleable: 34,
        salePricePerSqftSaleable: 0,
        leasePricePerSqft: 34,
        salePricePerSqft: 0,
        size: 1730,
        sizeGross: 2248,
        sizeSaleable: 1730,
        amenities: [
            {
                key: 'bed',
                value: 4,
                displayKey: 'Bedrooms',
                displayValue: '4 BD',
            },
            {
                key: 'bath',
                value: 4,
                displayKey: 'Bathroom',
                displayValue: '4 BA',
            },
            {
                key: 'maid',
                value: 1,
                displayKey: "Maid's Room",
                displayValue: '1 MR',
            },
            {
                key: 'balcony',
                value: 2,
                displayKey: 'Balcony',
                displayValue: '2 BL',
            },
        ],
        buildingAge: 13,
        floor: 'Low',
        isSaved: false,
        isSaving: false,
        lastUpdated: '2018-09-18T15:02:47',
        referenceId: 296046,
        lat: 22.308039,
        lng: 114.012889,
        isRelated: false,
        isSaleSubjectToOffer: false,
        isLeaseSubjectToOffer: false,
        isSubjectToOffer: false,
    },
];
exports.defaultDetailSaleList = [
    {
        banners: [],
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.INCLUDE,
        images: [
            {
                path: "https://images.okay.com/Property/Folder150/bella-vista-mid-levels-west-for-sale-1270_637413257023892019.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/bella-vista-mid-levels-west-for-sale-1270_637413256927118479.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/bella-vista-mid-levels-west-for-sale-1270_637413256879383393.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/bella-vista-mid-levels-west-for-sale-1270_637413257063902866.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/bella-vista-mid-levels-west-for-sale-1270_637413256785865902.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/bella-vista-mid-levels-west-for-sale-1270_637413256726155150.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/bella-vista-mid-levels-west-for-sale-1270_637413256836945543.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/bella-vista-mid-levels-west-for-sale-1270_637413256642192540.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/bella-vista-mid-levels-west-for-sale-1270_637413256590280134.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/bella-vista-mid-levels-west-for-sale-1270_637413256685640028.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/bella-vista-mid-levels-west-for-sale-1270_637413256546799572.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/bella-vista-mid-levels-west-for-sale-1270_637413256976331526.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Building/Original/bella-vista-for-sale-3713_636469444578500962.jpg",
                caption: "Building Photo"
            },
            {
                path: "https://images.okay.com/Building/Original/bella-vista-for-sale-3713_636469444585676975.jpg",
                caption: "Building Photo"
            },
            {
                path: "https://images.okay.com/Building/Original/bella-vista-for-sale-3713_636469444593944989.jpg",
                caption: "Building Photo"
            },
            {
                path: "https://images.okay.com/Building/Original/bella-vista-for-sale-3713_637099315593668953.jpg",
                caption: "Building Photo"
            }
        ],
        building: "Bella Vista",
        area: "Mid-levels West",
        address: "3 Ying Fai Terrace",
        type: 2,
        price: 7500000,
        salePrice: 7500000,
        leasePrice: 19000,
        leasePricePerSqftGross: 41,
        salePricePerSqftGross: 16234,
        leasePricePerSqftSaleable: 62,
        salePricePerSqftSaleable: 24510,
        leasePricePerSqft: 62,
        salePricePerSqft: 24510,
        pricePerSqft: 24510,
        size: 306,
        sizeGross: 462,
        sizeSaleable: 306,
        amenities: [
            {
                key: "bed",
                value: 2,
                displayKey: "Bedrooms",
                displayValue: "2 BD"
            },
            {
                key: "bath",
                value: 1,
                displayKey: "Bathroom",
                displayValue: "1 BA"
            }
        ],
        buildingAge: 21,
        floor: "Low",
        isSaved: false,
        isSaving: false,
        lastUpdated: "2021-05-06T00:00:00",
        referenceId: 1270,
        lat: 22.28148,
        lng: 114.151065,
        isRelated: false,
        isSaleSubjectToOffer: false,
        isLeaseSubjectToOffer: false,
        isSubjectToOffer: false,
        districtId: 17,
        isVirtual: false,
        isVideo: null,
        isSoleAgent: null,
        isJointSoleAgent: null,
        agentImage: null,
        agentName: null,
    },
    {
        banners: [],
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.INCLUDE,
        images: [
            {
                path: "https://images.okay.com/Property/Folder150/floral-tower-mid-levels-west-for-sale-90220_637287876318332938.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/floral-tower-mid-levels-west-for-sale-90220_637287876418868816.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/floral-tower-mid-levels-west-for-sale-90220_637287876650216080.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/floral-tower-mid-levels-west-for-sale-90220_637287876770028196.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/floral-tower-mid-levels-west-for-sale-90220_637287876916215483.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/floral-tower-mid-levels-west-for-sale-90220_637287877006995871.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/floral-tower-mid-levels-west-for-sale-90220_637287877118357468.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/floral-tower-mid-levels-west-for-sale-90220_637287877214447881.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/floral-tower-mid-levels-west-for-sale-90220_637287877394753753.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/floral-tower-mid-levels-west-for-sale-90220_637287877500951404.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/floral-tower-mid-levels-west-for-sale-90220_637287877578089237.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/floral-tower-mid-levels-west-for-sale-90220_637287877676723841.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Building/Original/floral-tower-for-sale-485_636511077004423733.jpg",
                caption: "Building Photo"
            },
            {
                path: "https://images.okay.com/Building/Original/floral-tower-for-sale-485_636511077021271763.jpg",
                caption: "Building Photo"
            }
        ],
        building: "Floral Tower",
        area: "Mid-levels West",
        address: "22 Robinson Road",
        type: 0,
        price: 7900000,
        salePrice: 7900000,
        leasePrice: 0,
        leasePricePerSqftGross: 0,
        salePricePerSqftGross: 18119,
        leasePricePerSqftSaleable: 0,
        salePricePerSqftSaleable: 22965,
        leasePricePerSqft: 0,
        salePricePerSqft: 22965,
        pricePerSqft: 22965,
        size: 344,
        sizeGross: 436,
        sizeSaleable: 344,
        amenities: [
            {
                key: "bed",
                value: 2,
                displayKey: "Bedrooms",
                displayValue: "2 BD"
            },
            {
                key: "bath",
                value: 1,
                displayKey: "Bathroom",
                displayValue: "1 BA"
            }
        ],
        buildingAge: 29,
        floor: "Low",
        isSaved: false,
        isSaving: false,
        lastUpdated: "2021-04-29T00:00:00",
        referenceId: 90220,
        lat: 22.280916,
        lng: 114.150394,
        isRelated: false,
        isSaleSubjectToOffer: false,
        isLeaseSubjectToOffer: false,
        isSubjectToOffer: false,
        districtId: 17,
        isVirtual: false,
        isVideo: null,
        isSoleAgent: null,
        isJointSoleAgent: null,
        agentImage: null,
        agentName: null,
    },
    {
        banners: [],
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.INCLUDE,
        images: [
            {
                path: "https://images.okay.com/Property/Folder150/floral-tower-mid-levels-west-for-sale-5716_636486026194641649.JPG",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/floral-tower-mid-levels-west-for-sale-5716_636486026034897368.JPG",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/floral-tower-mid-levels-west-for-sale-5716_636486026059077411.JPG",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/floral-tower-mid-levels-west-for-sale-5716_636486026084817456.JPG",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/floral-tower-mid-levels-west-for-sale-5716_636486026123037523.JPG",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/floral-tower-mid-levels-west-for-sale-5716_636486026167965602.JPG",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/floral-tower-mid-levels-west-for-sale-5716_636486026222877699.JPG",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/floral-tower-mid-levels-west-for-sale-5716_636486026279349798.JPG",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/floral-tower-mid-levels-west-for-sale-5716_636486026307273847.JPG",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Building/Original/floral-tower-for-sale-485_636511077004423733.jpg",
                caption: "Building Photo"
            },
            {
                path: "https://images.okay.com/Building/Original/floral-tower-for-sale-485_636511077021271763.jpg",
                caption: "Building Photo"
            }
        ],
        building: "Floral Tower",
        area: "Mid-levels West",
        address: "22 Robinson Road",
        type: 2,
        price: 8200000,
        salePrice: 8200000,
        leasePrice: 22000,
        leasePricePerSqftGross: 50,
        salePricePerSqftGross: 18807,
        leasePricePerSqftSaleable: 64,
        salePricePerSqftSaleable: 23837,
        leasePricePerSqft: 64,
        salePricePerSqft: 23837,
        pricePerSqft: 23837,
        size: 344,
        sizeGross: 436,
        sizeSaleable: 344,
        amenities: [
            {
                key: "bed",
                value: 1,
                displayKey: "Bedrooms",
                displayValue: "1 BD"
            },
            {
                key: "bath",
                value: 1,
                displayKey: "Bathroom",
                displayValue: "1 BA"
            }
        ],
        buildingAge: 29,
        floor: "High",
        isSaved: false,
        isSaving: false,
        lastUpdated: "2021-05-06T00:00:00",
        referenceId: 5716,
        lat: 22.280916,
        lng: 114.150394,
        isRelated: false,
        isSaleSubjectToOffer: false,
        isLeaseSubjectToOffer: false,
        isSubjectToOffer: false,
        districtId: 17,
        isVirtual: false,
        isVideo: null,
        isSoleAgent: null,
        isJointSoleAgent: null,
        agentImage: null,
        agentName: null,
    },
    {
        banners: [],
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.INCLUDE,
        images: [
            {
                path: "https://images.okay.com/Property/Folder150/maxluck-court-mid-levels-west-for-sale-103759_637384671694408569.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/maxluck-court-mid-levels-west-for-sale-103759_637384671642040490.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/maxluck-court-mid-levels-west-for-sale-103759_637384671668400317.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/maxluck-court-mid-levels-west-for-sale-103759_637384671719608696.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/maxluck-court-mid-levels-west-for-sale-103759_637384671747581742.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/maxluck-court-mid-levels-west-for-sale-103759_637384671774688076.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/maxluck-court-mid-levels-west-for-sale-103759_637384671619787689.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/maxluck-court-mid-levels-west-for-sale-103759_637384671579487135.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/maxluck-court-mid-levels-west-for-sale-103759_637384671800610092.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/maxluck-court-mid-levels-west-for-sale-103759_637384671833672910.jpg",
                caption: "Property Photo"
            }
        ],
        building: "Maxluck Court",
        area: "Mid-levels West",
        address: "12 Mosque Street",
        type: 0,
        price: 7900000,
        salePrice: 7900000,
        leasePrice: 0,
        leasePricePerSqftGross: 0,
        salePricePerSqftGross: 11111,
        leasePricePerSqftSaleable: 0,
        salePricePerSqftSaleable: 20000,
        leasePricePerSqft: 0,
        salePricePerSqft: 20000,
        pricePerSqft: 20000,
        size: 395,
        sizeGross: 711,
        sizeSaleable: 395,
        amenities: [
            {
                key: "bed",
                value: 1,
                displayKey: "Bedrooms",
                displayValue: "1 BD"
            },
            {
                key: "bath",
                value: 1,
                displayKey: "Bathroom",
                displayValue: "1 BA"
            }
        ],
        buildingAge: 29,
        floor: "Mid",
        isSaved: false,
        isSaving: false,
        lastUpdated: "2021-04-12T00:00:00",
        referenceId: 103759,
        lat: 22.279819,
        lng: 114.152157,
        isRelated: false,
        isSaleSubjectToOffer: false,
        isLeaseSubjectToOffer: false,
        isSubjectToOffer: false,
        districtId: 17,
        isVirtual: false,
        isVideo: null,
        isSoleAgent: null,
        isJointSoleAgent: null,
        agentImage: null,
        agentName: null,
    },
    {
        banners: [],
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.INCLUDE,
        images: [
            {
                path: "https://images.okay.com/Property/Folder150/woodlands-court-mid-levels-west-for-sale-81415_636927695650940716.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/woodlands-court-mid-levels-west-for-sale-81415_636927695474657326.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/woodlands-court-mid-levels-west-for-sale-81415_636927695522550247.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/woodlands-court-mid-levels-west-for-sale-81415_636927695567479111.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/woodlands-court-mid-levels-west-for-sale-81415_636927695765602921.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/woodlands-court-mid-levels-west-for-sale-81415_636927695917549843.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/woodlands-court-mid-levels-west-for-sale-81415_636927695961698692.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Building/Original/woodlands-court-for-sale-759_634083355890937500.JPG",
                caption: "Building Photo"
            },
            {
                path: "https://images.okay.com/Building/Original/woodlands-court-for-sale-759_634083356992031250.JPG",
                caption: "Building Photo"
            },
            {
                path: "https://images.okay.com/Building/Original/woodlands-court-for-sale-759_634083357085781250.JPG",
                caption: "Building Photo"
            },
            {
                path: "https://images.okay.com/Building/Original/woodlands-court-for-sale-759_634083358733750000.JPG",
                caption: "Building Photo"
            },
            {
                path: "https://images.okay.com/Building/Original/woodlands-court-for-sale-759_634083363996093750.JPG",
                caption: "Building Photo"
            }
        ],
        building: "Woodlands Court",
        area: "Mid-levels West",
        address: "1 Woodlands Terrace",
        type: 2,
        price: 8000000,
        salePrice: 8000000,
        leasePrice: 18000,
        leasePricePerSqftGross: 33,
        salePricePerSqftGross: 14545,
        leasePricePerSqftSaleable: 48,
        salePricePerSqftSaleable: 21220,
        leasePricePerSqft: 48,
        salePricePerSqft: 21220,
        pricePerSqft: 21220,
        size: 377,
        sizeGross: 550,
        sizeSaleable: 377,
        amenities: [
            {
                key: "bed",
                value: 1,
                displayKey: "Bedrooms",
                displayValue: "1 BD"
            },
            {
                key: "bath",
                value: 1,
                displayKey: "Bathroom",
                displayValue: "1 BA"
            }
        ],
        buildingAge: 28,
        floor: "High",
        isSaved: false,
        isSaving: false,
        lastUpdated: "2021-05-12T00:00:00",
        referenceId: 81415,
        lat: 22.2818,
        lng: 114.150701,
        isRelated: false,
        isSaleSubjectToOffer: false,
        isLeaseSubjectToOffer: false,
        isSubjectToOffer: false,
        districtId: 17,
        isVirtual: false,
        isVideo: null,
        isSoleAgent: null,
        isJointSoleAgent: null,
        agentImage: null,
        agentName: null,
    },
    {
        banners: [],
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.INCLUDE,
        images: [
            {
                path: "https://images.okay.com/Property/Folder150/jadestone-court-mid-levels-west-for-sale-95943_637556541831760793.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/jadestone-court-mid-levels-west-for-sale-95943_637556541690149167.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/jadestone-court-mid-levels-west-for-sale-95943_637556541708849291.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/jadestone-court-mid-levels-west-for-sale-95943_637556541736800225.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/jadestone-court-mid-levels-west-for-sale-95943_637556541763610357.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/jadestone-court-mid-levels-west-for-sale-95943_637556541811260534.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/jadestone-court-mid-levels-west-for-sale-95943_637556541852510720.jpg",
                caption: "Property Photo"
            },
            {
                path: "https://images.okay.com/Property/Folder150/jadestone-court-mid-levels-west-for-sale-95943_637556541884910858.jpg",
                caption: "Property Photo"
            }
        ],
        building: "Jadestone Court",
        area: "Mid-levels West",
        address: "138 Caine Road / 49 Seymour Road",
        type: 0,
        price: 7800000,
        salePrice: 7800000,
        leasePrice: 0,
        leasePricePerSqftGross: 0,
        salePricePerSqftGross: 17333,
        leasePricePerSqftSaleable: 0,
        salePricePerSqftSaleable: 23494,
        leasePricePerSqft: 0,
        salePricePerSqft: 23494,
        pricePerSqft: 23494,
        size: 332,
        sizeGross: 450,
        sizeSaleable: 332,
        amenities: [
            {
                key: "bed",
                value: 1,
                displayKey: "Bedrooms",
                displayValue: "1 BD"
            },
            {
                key: "bath",
                value: 1,
                displayKey: "Bathroom",
                displayValue: "1 BA"
            }
        ],
        buildingAge: 30,
        floor: "Mid",
        isSaved: false,
        isSaving: false,
        lastUpdated: "2021-05-03T00:00:00",
        referenceId: 95943,
        lat: 22.282837,
        lng: 114.14924,
        isRelated: false,
        isSaleSubjectToOffer: false,
        isLeaseSubjectToOffer: false,
        isSubjectToOffer: false,
        districtId: 17,
        isVirtual: false,
        isVideo: null,
        isSoleAgent: null,
        isJointSoleAgent: null,
        agentImage: null,
        agentName: null,
    }
];
